import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const searchPlan = async (body): Promise<[]> => {
  localStorage.setItem("searchInfo", JSON.stringify(body));
  const { data } = await axiosConsumer.post("/search_plan", body);
  return data;
};

export const insertWarrntyItem = async (body): Promise<[]> => {
  const { data } = await axiosConsumer.post(`/insert_manual_warr_item`, body);
  return data;
};

export const getPlanById = async (warrantyId: Number | string) => {
  const { data } = await axiosConsumer.get(`/plan/${warrantyId}`);
  return data;
};

export const aceGetplanById = async (warrantyId, custId, claimId = 1) => {
  const { data } = await axiosConsumer.get(
    `/ace/plan/${warrantyId}?customerId=${custId}&claimId=${claimId}`
  );
  return data;
};
